import api from '@/api/user'

import password from '@/sui/tools/password'
import pwd from '@/sui/store/password'

const state = {
  token: '',
  status: 'disconnected',
  info: {
    /*
      id,
      name,
      firstName,
      email,
      preferences,
    */
  },
  surveys: {
    surveillance2019: 'unknown'
  },
  jobs: [
    { code: 'ANE-REA', name: 'Anesthésiste/Réanimateur' },
    { code: 'AUTRE', name: 'Autre' },
    { code: 'BIO-HYG', name: 'Bio-Hygiéniste' },
    { code: 'BIOL', name: 'Biologiste' },
    { code: 'CADR SANTE', name: 'Cadre de santé' },
    { code: 'CADR SF', name: 'Cadre sage femme' },
    { code: 'CHIR', name: 'Chirurgien' },
    { code: 'DIR', name: 'Directeur' },
    { code: 'DG', name: 'Directeur Général' },
    { code: 'DOc', name: 'Documentaliste' },
    { code: 'IDE', name: 'IDE' },
    { code: 'INFECT', name: 'Infectiologue' },
    { code: 'INGE', name: 'Ingénieur' },
    { code: 'MED', name: 'Médecin' },
    { code: 'MED DIM', name: 'Médecin DIM' },
    { code: 'MED TRAV', name: 'Médecin du travail' },
    { code: 'NP', name: 'Non Précisé' },
    { code: 'PHAM', name: 'Pharmacien ' },
    { code: 'PRAT', name: 'Praticien' },
    { code: 'QUAL', name: 'Responsable qualité/Qualiticien' },
    { code: 'SAG FEM', name: 'Sage-femme' },
    { code: 'SECR', name: 'Secrétaire/Assistant' }
  ]
}

const getters = {
  isSessionExpired: state => {
    return state.status === 'expired'
  },

  isLoggedIn: state => {
    return state.status === 'connected'
  },

  token: state => {
    return state.status === 'connected' ? state.token : ''
  },

  completeName: state => {
    return `${state.info.firstName} ${state.info.name}`
  },

  email: state => {
    if (state.info.email == null) {
      return ''
    }
    return `${state.info.email[0]}`
  },

  id: state => {
    return `${state.info.id}`
  },

  surveyState: state => type => {
    return state.surveys[type]
  }
}

// actions
const actions = {
  login ({ commit }, request) {
    commit('setStatus', 'connecting')
    const pwdHash = password(request.email, request.password)
    return api.login(request.email, pwdHash).then((response) => {
      if ((response.data.err == null) && (response.data.t != null)) {
        commit('setStatus', 'connected')
        commit('setPwdStatus', '')
        commit('setToken', response.data.t)
        commit('setInfo', response.data.u)
      }
      return response
    })
  },

  logout ({ commit }, reason) {
    commit('logout')
    commit('setStatus', reason)
  },

  checkSurvey ({ commit }, request) {
    return api.checkSurvey(request).then(
      (response) => {
        if (response.data.err == null) {
          commit('setSurveyState', { t: request.t, v: response.data.v })
        }
        return response
      }
    )
  },

  answerSurvey ({ commit }, request) {
    return api.answerSurvey(request).then(
      (response) => {
        if (response.data.err == null) {
          commit('setPreference', { p: request.n, v: true })
        }
        return response
      }
    )
  }
}

const preferences = [
  { name: 'showHints', default: false },
  { name: 'autoNext', default: true },
  { name: 'firstCheat', default: false },
  { name: 'fixedNav', default: false }
]

for (let i in preferences) {
  const p = preferences[i]
  getters[p.name] = state => {
    if (state.info.preferences == null) {
      return p.default
    }

    let value = state.info.preferences[p.name]
    return value != null ? value === 2 : p.default
  }

  actions[p.name] = function ({ state, commit }, value) {
    commit('setPreference', { p: p.name, v: value })
    return api.updatePreferences(state.info.id, state.info.preferences)
  }
}

// mutations
const mutations = {
  setStatus (state, status) {
    state.status = status
  },

  setPwdStatus (state, status) {
    pwd.state.status = status
  },

  setToken (state, token) {
    state.token = token
  },

  setInfo (state, info) {
    state.info = info

    const p = info.preferences != null ? info.preferences : {}
    for (let i in preferences) {
      const name = preferences[i].name
      const defaultValue = preferences[i].default
      if (p[name] == null || p[name] === 0) {
        p[name] = defaultValue ? 2 : 1
      }
    }
    state.info.preferences = p
  },

  logout (state) {
    state.token = ''
    state.info = {}
    state.surveys.surveillance2019 = 'unknown'
  },

  setPreference (state, value) {
    state.info.preferences[value.p] = value.v
  },

  setSurveyState (state, value) {
    state.surveys[value.t] = value.v ? 'done' : 'todo'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
